export var RSVForm = {
    id: 1,
    langcode: 'de',
    type: 'placeholder',
    status: true,
    parent_field_name: 'field_paragraphs',
    content_translation_changed: '2021-04-19T08:33:08+00:00',
    field_distance: 'default',
    field_placeholder_variants: 'formRsv',
    field_type: 'placeholder',
    data: {
        target_id: '1',
        target_revision_id: '1',
    },
    field_name: 'field_paragraphs',
};
export var MockDataSuccess = {
    resultType: 'MESSAGE_DELIVERED',
    successful: true,
};
//# sourceMappingURL=index.js.map